import {useQuery} from '@tanstack/react-query';
import {useAxios} from '../../hooks/axios/useAxios';
import {acknowledgementUrl, marketplaceInstitutionsUrl} from "../../constants/api/soft-user/endpoints";

interface QueryParams {
  portfolio_id?: string,
  institution_message_id?: string
}

export const useQueryAcknowledgement = (params: QueryParams) => {
  const {
    portfolio_id,
    institution_message_id
  } = params;
  const axios = useAxios();

  const handleRequest = () => {
    if (portfolio_id && institution_message_id) {
      return axios.get(acknowledgementUrl, {params})
        .then(response => response?.data ?? response);
    }
    return {};
  };

  return useQuery({
    queryKey: ['acknowledgement-user', params],
    queryFn: handleRequest,
    retry: 1
  })
};
